/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type BottomBar_viewer = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BottomBar_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "VipAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SiteNav_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
